import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { LanguageProvider } from './shared/language-provider';
import { HttpRequestInterceptor } from './shared/services/http-interceptor.service.spec';
import { LoadingInterceptor } from './shared/services/loading-interceptor';
import { APP_BASE_HREF } from '@angular/common';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { firstValueFrom } from 'rxjs';

export let appSettings: any;

export function loadAppSettings(handler: HttpBackend) {
  return () => {
    const http = new HttpClient(handler);
    return firstValueFrom(
      http.get('/assets/appsettings.json')
    ).then(settings => {
      appSettings = settings;
    });
  };
}

export function languagesProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}

export function socialAuthServiceConfigFactory(): SocialAuthServiceConfig {
  return {
    autoLogin: false,
    providers: [
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(appSettings?.googleClientId)
      },
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider(appSettings?.facebookAppId, {
          scopes: 'email,public_profile',
          return_scopes: true,
          enable_profile_selector: true
        })
      }
    ],
    onError: (err) => {
      console.error(err);
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()), // Removed duplicate provideHttpClient() calls
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: loadAppSettings,
      deps: [HttpBackend],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: languagesProviderFactory,
      deps: [LanguageProvider],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: DateAdapter, useClass: NativeDateAdapter },
    {
      provide: 'SocialAuthServiceConfig',
      useFactory: socialAuthServiceConfigFactory // Switched from useValue to useFactory
    }
  ]
};